+function($, window, document) {
	var scope;
	
	var Ratings = function(element, options) {
		this.$element = $(element);		
		this.options = options;
		
		this.initialize();
	};
	
	Ratings.DEFAULTS = {
		starSelector: '.rating i'		
	};
	
	Ratings.prototype.initialize = function() {
		scope = this;

		this.$stars = this.$element.find(this.options.starSelector);
		this.$ratingField = this.$element.find('input[name="rating"]');

		this.initRatings();
		this.observeClickStar();
		this.moveOnStar();

		this.$element.on('mouseleave', function() {
			scope.showRating(scope.$ratingField.val());
		});
	};

	Ratings.prototype.initRatings = function() {
		this.$stars.each(function(index, star) {
			var $star = $(star);

			$star.data('rating', index + 1);
		});
	};

	Ratings.prototype.observeClickStar = function() {
		this.$element.on('click', this.options.starSelector, function() {
			scope.$ratingField.val($(this).data('rating'));
		});
	};

	Ratings.prototype.moveOnStar = function() {
		this.$element.on('mousemove', this.options.starSelector, function() {
			var currentRating = $(this).data('rating');

			scope.showRating(currentRating);
		});
	};

	Ratings.prototype.showRating = function(rating) {
		scope.$stars.each(function(index, star) {
			var $star = $(star);

			if ($star.data('rating') <= rating) {
				$star.addClass("icon-star").removeClass('icon-star-empty');
			}else {
				$star.addClass("icon-star-empty").removeClass('icon-star');
			}
		});
	};
	
	function Plugin(option) {
		var $this   = $(this),
			data   	= $this.data('sn.ratings'),
			options = $.extend({}, Ratings.DEFAULTS, typeof option == 'object' && option);
		  
		if ( ! data) {
			$this.data('sn.ratings', (data = new Ratings(this, options)));  
		} 
		  
		if (typeof option == 'string') {
			data[option]();  
		} 
	}
	
	$.fn.ratings = Plugin;
	$.fn.ratings.Constructor = Ratings;
			
	//data-api
	$(function() {
		$('[data-toggle="ratings"]').each(function () {
			var $element = $(this);
		  
			Plugin.call($element, $element.data())
		});
	})
}(jQuery, window, document);